export default "https://cdn-static.gokick.com/assets/7f5563240f0a87948aacfb3375d791c4357d9b8c/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";